import { createStore } from 'vuex'
import { mainLangValues } from '../plugins/language.js'
import { errorCodes } from '../plugins/error-code.js'

export default createStore({
    state: {
        langValues: Object.assign({}, mainLangValues, errorCodes),        
        evtApiServer: process.env.VUE_APP_API_SERVER,
        evtBase: {},
        country: null,
        lang: '',
    },
    getters: {
        getLangValue: (state) => (transCode) => {
            let lang = state.langValues[transCode]
            if (lang) {
                return lang[state.lang]?.replace('\n', '<br/>') ?? `Not found text Key/Lang=>(${transCode}/${state.lang})`
            }
            else {
                return `Not found text Key=>(${transCode})`
            }
        },
    },
    mutations: {
    },
    actions: {
    },
    modules: {
    }
})
